import { AnyFunc, Methods, Method } from '#utils/typeUtils'
import type { SegmentedClientInterface } from '../api/SegmentedClientInterface'

export const bindMethods = <
  T extends Record<string, unknown>,
  U extends Record<string, AnyFunc>,
  D extends Record<string, U>,
>(
  instance: SegmentedClientInterface,
  deps: T,
  declaration: D,
) => {
  const keys = Object.keys(declaration)
  if (keys.length !== 1) {
    throw new Error('Only one object key is allowed in bindMethods')
  }

  const parentKey = keys[0] as string
  const methods = declaration[parentKey] as U

  return Object.entries(methods).reduce((acc, [key, method]) => {
    const fn = method.bind(instance, deps) as Method<typeof method>

    fn.getKey = (...params: Parameters<Method<typeof method>>) =>
      `${instance.prefix}.${parentKey}.${key}${
        params.length && params[0] !== undefined
          ? `:${JSON.stringify(params)}`
          : ''
      }`

    return {
      ...acc,
      [key]: fn,
    }
  }, {} as Methods<U>)
}
